// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"45":"1034bf85","787":"27d24870"}[chunkId] + ".chunk.js";
};